import { OMath } from "./OMath";

export class Percentage {
  static format(value = 0) {
    return value.toLocaleString("pt-br", {
      style: "decimal",
      maximumFractionDigits: 2,
    });
  }

  static fromValue(value, total) {
    if (total === 0) {
      return 0;
    }

    const percentage = OMath.div(value, total);
    return OMath.times(percentage, 100);
  }

  static fromValues(values = {}) {
    const total = OMath.sum(
      ...Object.entries(values).map(([key, value]) => value)
    );

    const percentages = {};

    Object.entries(values).forEach(([key, value]) => {
      percentages[key] = Percentage.fromValue(value, total);
    });

    return percentages;
  }
}
